<!-- Header section -->
<login-header></login-header>

<!-- FC Hero area -->
<div class="fc-career-hero" style="background-image: url('assets/images/career-hero.webp');">
    <div class="about-career-container content-width">
        <div class="career-hero-content">
            <h1 class="about-heading">Careers at Family Central</h1>
            <p>Come work with us to empower families with Family Central</p>
        </div>
    </div>
</div>

<div class="careers-accordion-wrapper">
    <div class="content-width">

        <div ngbAccordion [destroyOnHide]="false" [closeOthers]="true" activeIds="panel1" #shadow="ngbAccordion">
            <div ngbAccordionItem="panel1">
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="about-heading">UI Designer</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                    <div class="careers-accordion-content">
                        <div class="accordion-content">
                            <h3>About the job</h3>
                            <div class="founders-details">
                                <p>We're looking for a mid-senior level UI Designer with top notch figma skills to join our team. From concept to execution and fine tuning, you will be helping lead design projects from start to finish. This position works closely with our Creative Director and project managers. If you are a mid-senior level UI Designer with experience in web/mobile products, please apply!</p>
        
                                <p>Family Central is a team of D2C professionals that have worked together on prior successful companies that joined back together to create an important family application that can help people to live happier lives. Our overarching goal is to remove chaos from daily life by taking the steps to be prepared for emergencies and tragedies. We are looking to add 1-2 individuals to join us to further our design development functionality and work directly with our in-house technology team.</p>
        
                                <p>This can be a full time or contract opportunity for the right individual. Full Time Salary with benefits and potentially options in the company or contract payment commensurate with your experience.</p>
        
                                <button type="button" class="primary_btn" data-bs-toggle="modal" data-bs-target="#applyNow">Apply Now</button>
                            </div>
                        </div>

                        <div class="accordion-content bright-blue-bg">
                            <h3>Required Qualifications:</h3>
                            <div class="founders-details">
                                <ul class="skill-lists">
                                    <li>5+ years design expertise and design portfolio demonstrating understanding of design
                                        across various
                                        devices, formats and contexts (Web, Mobile – iOS, Android)</li>
                                    <li>Solid understanding of responsive design including up-to-date UI/UX best practices</li>
                                    <li>Highly proficient with current design software including Figma, Creative Suite, and
                                        zeplin</li>
                                    <li>Background with UI composition, grid systems, typography color, iconography, use of
                                        photography</li>
                                    <li>Understanding of HTML and CSS that informs design and interaction decisions.</li>
                                    <li>Can adapt a design process to support rapid prototyping</li>
                                    <li>Familiar with usability testing</li>
                                    <li>Excellent communication, collaboration, and problem-solving skills</li>
                                    <li>Ability to work in a start-up environment</li>
                                    <li>Present visual designs to various stakeholders.</li>
                                </ul>
                            </div>
                        </div>

                        <div class="accordion-content">
                            <h3>Essential Duties and Responsibilities:</h3>
                            <div class="founders-details">
                                <ul class="skill-lists">
                                    <li>Work effectively in a fast-moving environment, juggle multiple projects, and prioritize work</li>
                                    <li>Collaborate with our in-house developers, design lead, and marketing to help define the user experience for new and existing projects</li>
                                    <li>Contribute ideas for improving design process and deliverables</li>
                                </ul>

                                <button type="button" class="primary_btn">Apply Now</button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- Apply Now Modal -->
<div class="modal fade apply-modal default_modal" id="applyNow" role="dialog" aria-label="Apply Now" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-bs-dismiss="modal"><img src="/assets/img/close-icon.svg" alt="close icon"></button>

                <div class="apply-form-wrapper">
                    <div class="submit_msg d-flex">
                        <div class="message email_confirm" style="display: none;">
                            <span>Thank you!</span> Please check your email to confirm.
                        </div>
                    </div>

                    <form action="#" id="signup_form" novalidate="novalidate">
                        <div class="apply-form">
                            <div class="input-group">
                                <label for="fname">First Name<span>*</span></label>
                                <input type="text" id="fname" name="fname" class="form-control" required="">
                            </div>
                            <div class="input-group">
                                <label for="lname">Last Name<span>*</span></label>
                                <input type="text" id="lname" name="lname" class="form-control" required="">
                            </div>
                            <div class="input-group">
                                <label for="email">Email ID<span>*</span></label>
                                <input type="email" id="email" name="email" class="form-control" required="">
                            </div>
                            <div class="input-group">
                                <label for="phone">Phone Number<span>*</span></label>
                                <input type="text" id="phone" name="phone" class="form-control" required="">
                            </div>
                            <div class="input-group fullwidth">
                                <label for="position">Position</label>
                                <select class="form-control" name="position" id="position">
                                    <option value="" selected>UI Designer</option>
                                    <option value="">FrontEnd Developer</option>
                                </select>
                            </div>
                            <div class="input-group fullwidth">
                                <label for="resume-txt">Upload Resume</label>
                                <input type="file" id="resume" name="resume" class="">
                                <span class="help-text">(File formats: Doc, Docx and PDF )</span>
                            </div>
                            <div class="input-group submit-btn fullwidth">
                                <button type="submit" class="primary_btn">Apply Now</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer (showPrice)="showPricing()"></app-footer>

<ng-template #pricing>
    <app-pricing (onCancel)="onClose()"></app-pricing>
</ng-template>
